// ─────────────────────────────────────────────────────────────────────────────
// Google Analytics (gtag.js) loader — WEB ONLY.
//
// Intentionally NOT baked into public/index.html so the tag never fires
// inside the Capacitor iOS shell. That keeps us out of App Store
// tracking-review territory (Apple scans for common analytics domains
// and requires an ATT prompt for on-device tracking) — the iOS build
// simply skips the injection.
//
// On the web, this is injected once at boot after `isNativeIOS()`
// confirms we are not running inside Capacitor. The load is async so it
// can't block the initial paint or hurt Core Web Vitals.
// ─────────────────────────────────────────────────────────────────────────────

import { isNativeIOS } from "./platform";

const MEASUREMENT_ID = "G-1YV2EDJZKN";
let installed = false;

export function installGoogleAnalytics() {
  if (installed) return;
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (isNativeIOS()) return;             // Capacitor iOS opt-out
  installed = true;

  // 1) Inject the async loader script.
  const loader = document.createElement("script");
  loader.async = true;
  loader.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(loader);

  // 2) Inject the inline bootstrap that Google's snippet uses.
  const init = document.createElement("script");
  init.text = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${MEASUREMENT_ID}');
  `;
  document.head.appendChild(init);
}
